var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var _t = { locale: "en", duration: 400, ease: "cubic-bezier(0.19, 1, 0.22, 1)", disabled: false, respectReducedMotion: true };
function Dt(e, t, n) {
  if (n < 1) {
    let u = t * Math.sqrt(1 - n * n);
    return 1 - Math.exp(-n * t * e) * (Math.cos(u * e) + n * t / u * Math.sin(u * e));
  }
  let i = Math.sqrt(n * n - 1), r = -t * (n + i), s = -t * (n - i), o = -r / (s - r);
  return 1 - (1 - o) * Math.exp(r * e) - o * Math.exp(s * e);
}
function Ie(e, t, n) {
  let s = 0;
  for (let o = 0; o < 10; o += 1e-3) if (Math.abs(Dt(o, e, t) - 1) > n) s = 0;
  else if (s += 1e-3, s > 0.1) return Math.ceil((o - s + 1e-3) * 1e3);
  return Math.ceil(10 * 1e3);
}
function Ft(e, t) {
  if (typeof e == "object") {
    let n = Le(e);
    return { ease: n.easing, duration: n.duration };
  }
  return { ease: e, duration: t };
}
var $t = /* @__PURE__ */ new Map();
function Le(e) {
  let { stiffness: t = 100, damping: n = 10, mass: i = 1, precision: r = 1e-3 } = e ?? {}, s = `${t}:${n}:${i}:${r}`, o = $t.get(s);
  if (o) return o;
  let a = Math.sqrt(t / i), u = n / (2 * Math.sqrt(t * i)), c = Ie(a, u, r), f = Math.min(100, Math.max(32, Math.round(c / 15))), l = [];
  for (let d = 0; d < f; d++) {
    let h = d / (f - 1) * (c / 1e3), M = d === f - 1 ? 1 : Dt(h, a, u);
    l.push(Math.round(M * 1e4) / 1e4 + "");
  }
  for (; l.length > 2 && l[l.length - 2] === "1"; ) l.splice(l.length - 2, 1);
  let m = { easing: `linear(${l.join(", ")})`, duration: c };
  return $t.set(s, m), m;
}
function G(e, t) {
  let n = e.length, i = t.length, r = Array.from({ length: n + 1 }, () => Array(i + 1).fill(0));
  for (let c = n - 1; c >= 0; c--) for (let f = i - 1; f >= 0; f--) r[c][f] = e[c] === t[f] ? r[c + 1][f + 1] + 1 : Math.max(r[c + 1][f], r[c][f + 1]);
  let s = [], o = [], a = 0, u = 0;
  for (; a < n && u < i; ) e[a] === t[u] ? (s.push(a), o.push(u), a++, u++) : r[a + 1][u] >= r[a][u + 1] ? a++ : u++;
  return [s, o];
}
var Ne = "\0n", ke = 0;
function ht() {
  return `${Ne}${ke++}`;
}
function k(e) {
  return e >= "0" && e <= "9";
}
function q(e) {
  for (let t of e) if (k(t)) return true;
  return false;
}
function gt(e) {
  let t = "";
  for (let n of e) !k(n) && !bt.includes(n) && (t += n);
  return t;
}
var bt = ".,'    ", He = "+-−(#", Oe = `%.,!?:;)"'”’`, _e = new RegExp("\\p{Sc}", "u");
function Pt(e, t) {
  return t.includes(e) || _e.test(e);
}
function J(e) {
  let t = 0, n = e.length;
  for (; t < n && Pt(e[t], He); ) t++;
  for (; n > t && Pt(e[n - 1], Oe); ) n--;
  if (t >= n || !k(e[t]) || !k(e[n - 1])) return false;
  for (let i = t; i < n; i++) {
    let r = e[i];
    if (!k(r) && !bt.includes(r)) return false;
  }
  return true;
}
function at(e) {
  return k(e) ? "digit" : "symbol";
}
var Ct = /* @__PURE__ */ new Map();
function xt(e) {
  var _a;
  let t = String(e), n = Ct.get(t);
  if (n) return n;
  let i = ".";
  try {
    i = ((_a = new Intl.NumberFormat(e).formatToParts(1.1).find((r) => r.type === "decimal")) == null ? void 0 : _a.value) ?? ".";
  } catch {
  }
  return Ct.set(t, i), i;
}
function U(e, t, n, i = ".") {
  let r = e.split("");
  if (!t || t.length === 0) return $e(r);
  let s = t.map((c) => c.string === " " ? " " : c.string), o = n != null ? De(s, r, n, i) : Fe(s, r, i), a = /* @__PURE__ */ new Set();
  for (let [, c] of o) a.add(t[c].id);
  let u = [];
  for (let c = 0; c < r.length; c++) {
    let f = r[c], l = at(f), m = f === " " ? " " : f;
    if (o.has(c)) {
      let d = o.get(c);
      u.push({ id: t[d].id, string: m, kind: l });
    } else {
      let d = ht();
      for (; a.has(d); ) d = ht();
      a.add(d), u.push({ id: d, string: m, kind: l });
    }
  }
  return u;
}
function $e(e) {
  return e.map((t) => ({ id: ht(), string: t === " " ? " " : t, kind: at(t) }));
}
function De(e, t, n, i) {
  let r = /* @__PURE__ */ new Map(), s = Xt(e, i), o = Xt(t, i), a = (m, d) => r.set(o[m], s[d]), u = 0;
  for (; u < o.length && o[u] < n; ) u++;
  let c = o.length - s.length;
  if (c > 0) {
    let m = u - c;
    for (let d = 0; d < m && d < s.length; d++) a(d, d);
    for (let d = u; d < o.length; d++) {
      let h = d - c;
      h >= 0 && h < s.length && a(d, h);
    }
  } else if (c < 0) {
    for (let m = 0; m < u && m < o.length; m++) a(m, m);
    for (let m = u; m < o.length; m++) {
      let d = m - c;
      d >= 0 && d < s.length && a(m, d);
    }
  } else for (let m = 0; m < o.length; m++) t[o[m]] === e[s[m]] && a(m, m);
  let f = Bt(e, i), l = Bt(t, i);
  for (let m = 1; m <= f.length && m <= l.length; m++) {
    let d = f[f.length - m], h = l[l.length - m];
    e[d] === t[h] && r.set(h, d);
  }
  return r;
}
function Kt(e, t) {
  return e !== t && bt.includes(e);
}
function Xt(e, t) {
  let n = [];
  for (let i = 0; i < e.length; i++) Kt(e[i], t) || n.push(i);
  return n;
}
function Bt(e, t) {
  let n = [];
  for (let i = 0; i < e.length; i++) Kt(e[i], t) && n.push(i);
  return n;
}
function Fe(e, t, n) {
  let i = /* @__PURE__ */ new Map(), r = 0;
  for (; r < e.length && r < t.length && e[r] === t[r] && !k(e[r]); ) i.set(r, r), r++;
  let s = e.length, o = t.length;
  for (; s > r && o > r && e[s - 1] === t[o - 1] && !k(e[s - 1]); ) i.set(o - 1, s - 1), s--, o--;
  let a = Ut(e, r, s, n), u = Ut(t, r, o, n), c = Gt(e, r, a), f = Gt(t, r, u);
  if (c > 0 && f > 0 && Math.abs(c - f) >= Pe) return i;
  if (!d(r, a, r, u, true)) for (let h = 1; a - h >= r && u - h >= r; h++) m(a - h, u - h);
  if (a < s && u < o) {
    i.set(u, a);
    for (let h = 1; a + h < s && u + h < o; h++) m(a + h, u + h);
    d(a + 1, s, u + 1, o, false);
  }
  function m(h, M) {
    let x = e[h];
    k(x) || x === t[M] && i.set(M, h);
  }
  function d(h, M, x, T, L) {
    let E = Wt(e, h, M), N = Wt(t, x, T);
    if (E.length === N.length || !L) {
      let A = Math.min(E.length, N.length);
      for (let _ = 0; _ < A; _++) {
        let B = E[_], rt = N[_];
        e[B] === t[rt] && i.set(rt, B);
      }
      return false;
    }
    let g = E.map((A) => e[A]).reverse(), v = N.map((A) => t[A]).reverse(), [R, O] = G(g, v);
    for (let A = 0; A < R.length; A++) {
      let _ = E[E.length - 1 - R[A]], B = N[N.length - 1 - O[A]];
      i.set(B, _);
    }
    return R.length > 0;
  }
  return i;
}
function Wt(e, t, n) {
  let i = [];
  for (let r = t; r < n; r++) k(e[r]) && i.push(r);
  return i;
}
var Pe = 3;
function Gt(e, t, n) {
  let i = 0;
  for (let r = t; r < n; r++) k(e[r]) && i++;
  return i;
}
function Ut(e, t, n, i) {
  for (let r = n - 1; r >= t; r--) if (e[r] === i) return r;
  return n;
}
function yt() {
  let e = /* @__PURE__ */ new Set();
  return { reserve(t) {
    e.add(t);
  }, has(t) {
    return e.has(t);
  }, take(t) {
    if (!e.has(t)) return e.add(t), t;
    let n = 1;
    for (; e.has(`${t}~${n}`); ) n++;
    let i = `${t}~${n}`;
    return e.add(i), i;
  } };
}
function zt(e) {
  let t = [], n = [], i = () => {
    n.length !== 0 && (t.push({ word: n.map((r) => r.string).join(""), segments: n }), n = []);
  };
  for (let r of e) r.string === " " || r.string === `
` ? i() : n.push(r);
  return i(), t;
}
function Yt(e) {
  let t = [], n = [], i = () => {
    if (n.length === 0) return;
    let r = n.map((s) => s.string).join("");
    J(r) ? t.push(...U(r)) : t.push(...n), n = [];
  };
  for (let r of e) r.string === " " || r.string === `
` ? (i(), t.push(r)) : n.push(r);
  return i(), t;
}
function K(e, t, n = true) {
  let i = e.includes(`
`), r = e.includes(" ") || i, s = yt();
  if (i) {
    let a = e.split(`
`), u = [], c = 0;
    return a.forEach((f, l) => {
      l > 0 && (u.push({ id: s.take(`newline-${c}`), string: `
` }), c += 1), f.length > 0 && u.push(...jt(f, t, true, c, s)), c += f.length;
    }), n ? Yt(u) : u;
  }
  let o = jt(e, t, r, 0, s);
  return n ? Yt(o) : o;
}
function jt(e, t, n, i, r) {
  if (typeof Intl.Segmenter < "u") {
    let s = new Intl.Segmenter(t, { granularity: n ? "word" : "grapheme" });
    return Ce(s.segment(e)[Symbol.iterator](), i, r);
  }
  return Xe(e, n, i, r);
}
function Ce(e, t, n) {
  let i = [];
  for (let r of Array.from(e)) {
    let s = t + r.index;
    r.segment === " " ? i.push({ id: n.take(`space-${s}`), string: " " }) : i.push({ id: qt(r.segment, s, n), string: r.segment });
  }
  return i;
}
function qt(e, t, n) {
  return n.has(e) ? n.take(`${e}-${t}`) : n.take(e);
}
function Xe(e, t, n, i) {
  let r = t ? e.split(" ") : e.split(""), s = [], o = n;
  return r.forEach((a, u) => {
    t && u > 0 && (s.push({ id: i.take(`space-${o}`), string: " " }), o += 1), s.push({ id: qt(a, o, i), string: a }), o += a.length;
  }), s;
}
var Y = "torph-root", Q = "torph-item", w = "torph-id", V = "torph-kind", F = "torph-slot", H = "torph-exiting", P = "torph-sr", Z = "torph-debug", tt = "empty";
var Be = { linear: [0, 0, 1, 1], ease: [0.25, 0.1, 0.25, 1], "ease-in": [0.42, 0, 1, 1], "ease-out": [0, 0, 0.58, 1], "ease-in-out": [0.42, 0, 0.58, 1] }, Jt = (e, t, n) => {
  let i = 1 - n;
  return 3 * i * i * n * e + 3 * i * n * n * t + n * n * n;
};
function Qt(e, t, n, i) {
  return (r) => {
    if (r <= 0) return 0;
    if (r >= 1) return 1;
    let s = 0, o = 1;
    for (let a = 0; a < 24; a += 1) {
      let u = (s + o) / 2;
      Jt(e, n, u) < r ? s = u : o = u;
    }
    return Jt(t, i, (s + o) / 2);
  };
}
function We(e) {
  let t = [...e];
  (t[0] === null || t[0] === void 0) && (t[0] = 0), t[t.length - 1] === null && (t[t.length - 1] = 1);
  for (let n = 1; n < t.length; n += 1) {
    if (t[n] !== null) continue;
    let i = n;
    for (; t[i] === null; ) i += 1;
    let r = t[n - 1], s = (t[i] - r) / (i - n + 1);
    for (let o = n; o < i; o += 1) t[o] = r + s * (o - n + 1);
  }
  return t.map((n, i, r) => i === 0 ? n : Math.max(n, r[i - 1]));
}
function Ge(e) {
  let t = [], n = [];
  for (let r of e.split(",")) {
    let s = r.trim().split(/\s+/).filter(Boolean), o = Number(s[0]);
    if (!Number.isFinite(o)) return null;
    let a = s.slice(1);
    if (a.length > 2) return null;
    if (a.length === 0) {
      t.push(o), n.push(null);
      continue;
    }
    for (let u of a) {
      if (!u.endsWith("%")) return null;
      let c = Number(u.slice(0, -1));
      if (!Number.isFinite(c)) return null;
      t.push(o), n.push(c / 100);
    }
  }
  if (t.length < 2) return null;
  let i = We(n);
  return (r) => {
    if (r <= i[0]) return t[0];
    let s = i.length - 1;
    if (r >= i[s]) return t[s];
    let o = 0;
    for (; o < s && i[o + 1] < r; ) o += 1;
    let a = i[o + 1] - i[o];
    return a === 0 ? t[o + 1] : t[o] + (t[o + 1] - t[o]) * (r - i[o]) / a;
  };
}
function Vt(e) {
  let t = e.trim().toLowerCase(), n = Be[t];
  if (n) return Qt(...n);
  let i = /^cubic-bezier\(([^)]*)\)$/.exec(t);
  if (i) {
    let s = i[1].split(",").map((o) => Number(o.trim()));
    return s.length !== 4 || s.some((o) => !Number.isFinite(o)) ? null : Qt(s[0], s[1], s[2], s[3]);
  }
  let r = /^linear\(([^)]*)\)$/.exec(t);
  return r ? Ge(r[1]) : null;
}
var St = 1e-4;
function Mt(e, t) {
  let n = Math.min(Math.max(t, 0), 1 - St);
  return (e(n + St) - e(n)) / St;
}
function lt(e, t) {
  return e * t;
}
function X(e) {
  let t = getComputedStyle(e).transform;
  if (!t || t === "none") return { tx: 0, ty: 0 };
  let n = t.match(/matrix\(([^)]+)\)/);
  if (!n) return { tx: 0, ty: 0 };
  let i = n[1].split(",").map(Number);
  return { tx: i[4] || 0, ty: i[5] || 0 };
}
function et(e) {
  let t = getComputedStyle(e), n = parseFloat(t.width), i = parseFloat(t.height);
  if (Number.isNaN(n) || Number.isNaN(i)) {
    let r = e.getBoundingClientRect();
    return { width: r.width, height: r.height };
  }
  return { width: n, height: i };
}
function j(e) {
  let { tx: t, ty: n } = X(e), i = Number(getComputedStyle(e).opacity) || 1;
  return e.getAnimations().forEach((r) => r.cancel()), { tx: t, ty: n, opacity: i };
}
var Ue = 8, Ke = 0.1, Ye = 0.5, je = 0.5, ee = () => performance.now();
function ze(e, t) {
  let n = Math.max(0, Math.min(Ue, t) - Mt(e, 0));
  if (!(n > 0)) return { curve: e, k: 0 };
  let i = Math.max(3, Math.ceil(n / (Math.E * Ke)) - 1);
  return { curve: (r) => r >= 1 ? 1 : e(r) + n * r * Math.pow(1 - r, i), k: n };
}
function qe(e, t) {
  let n = Math.min(120, Math.max(32, Math.round(t / 8))), i = [];
  for (let r = 0; r < n; r += 1) {
    let s = r / (n - 1), o = r === n - 1 ? 1 : e(s);
    i.push(`${Math.round(o * 1e4) / 1e4}`);
  }
  return `linear(${i.join(", ")})`;
}
function Zt(e, t, n, i, r, s, o, a) {
  let u = (m, d, h, M, x) => {
    let T = e.animate([{ [t]: `${m}px` }, { [t]: `${d}px` }], { duration: s, easing: h, fill: "both" });
    return x !== void 0 && (T.currentTime = x), { anim: T, from: m, to: d, easing: h, curve: M, startedAt: ee() - (x ?? 0) };
  };
  if (r && r.elapsed !== null && Math.abs(r.to - i) < je) return u(r.from, r.to, r.easing, r.curve, r.elapsed);
  let c = i - n, f = o, l = a;
  if (a && Math.abs(c) > Ye) {
    let m = ze(a, ((r == null ? void 0 : r.velocity) ?? 0) * s / c);
    m.k > 0 && (l = m.curve, f = qe(m.curve, s));
  }
  return u(n, i, f, l);
}
function te(e, t) {
  let n = e.anim.currentTime === null, i = ee() - e.startedAt, s = n || !Number.isFinite(i) || i >= t || i < 0 ? null : i;
  return { from: e.from, to: e.to, easing: e.easing, curve: e.curve, elapsed: s, velocity: s === null || !e.curve ? 0 : (e.to - e.from) * Mt(e.curve, s / t) / t };
}
var D = /* @__PURE__ */ new WeakMap();
function Je(e) {
  var _a;
  return (_a = D.get(e)) == null ? void 0 : _a.snapshot();
}
function ut(e) {
  e.style.width = "", e.style.height = "", e.style.transitionProperty = "";
}
function ne(e) {
  var _a;
  let t = D.get(e);
  t && (D.delete(e), t.stop(), (_a = t.onCancel) == null ? void 0 : _a.call(t));
}
function re(e) {
  let t = D.get(e);
  t && (D.delete(e), t.stop()), ut(e);
}
function ie(e, t, n, i, r, s, o) {
  let a = Je(e);
  if (ne(e), t === 0 || n === 0) {
    ut(e), o == null ? void 0 : o();
    return;
  }
  e.style.transitionProperty = "none", e.style.width = "", e.style.height = "", e.offsetWidth;
  let { width: u, height: c } = et(e), f = Vt(r), l = Zt(e, "width", t, u, a == null ? void 0 : a.width, i, r, f), m = Zt(e, "height", n, c, a == null ? void 0 : a.height, i, r, f), d = () => {
    l.anim.cancel(), m.anim.cancel();
  };
  l.anim.onfinish = () => {
    D.delete(e), d(), ut(e), s == null ? void 0 : s();
  }, D.set(e, { stop: d, onCancel: o, snapshot: () => ({ width: te(l, i), height: te(m, i) }) });
}
function se(e, t, n, i, r, s) {
  ne(e), e.style.transitionProperty = "none", e.style.width = `${t}px`, e.style.height = `${n}px`;
  let o = setTimeout(() => {
    D.delete(e), ut(e), r == null ? void 0 : r();
  }, i), a = (u) => ({ from: u, to: u, easing: "linear", curve: null, elapsed: null, velocity: 0 });
  D.set(e, { stop: () => clearTimeout(o), onCancel: s, snapshot: () => ({ width: a(t), height: a(n) }) });
}
function ct(e) {
  let t = Array.from(e.children), n = {}, i = e.getBoundingClientRect();
  return t.forEach((r, s) => {
    if (r.hasAttribute(H) || r.hasAttribute(P) || r.tagName === "BR") return;
    let o = r.getAttribute(w) || `child-${s}`, a = r.getBoundingClientRect(), { tx: u, ty: c } = X(r);
    n[o] = { x: a.left - i.left - u, y: a.top - i.top - c };
  }), n;
}
function Tt(e, t, n) {
  let i = e[n], r = t[n];
  return !i || !r ? { dx: 0, dy: 0 } : { dx: i.x - r.x, dy: i.y - r.y };
}
function Et(e, t, n, i = "backward-first") {
  let [r, s] = i === "backward-first" ? ["backward", "forward"] : ["forward", "backward"], o = (a) => {
    if (a === "backward") {
      for (let u = e - 1; u >= 0; u--) if (n.has(t[u])) return t[u];
    } else for (let u = e + 1; u < t.length; u++) if (n.has(t[u])) return t[u];
    return null;
  };
  return o(r) ?? o(s);
}
function oe(e, t, n, i) {
  let r = new Set(n.filter((o, a) => i.has(o) && !t.has(e[a]))), s = /* @__PURE__ */ new Map();
  for (let o = 0; o < e.length; o++) {
    let a = e[o];
    t.has(a) && s.set(a, Et(o, n, r, "forward-first"));
  }
  return s;
}
function ae(e, t) {
  let { dx: n, dy: i, duration: r, ease: s, scale: o } = t;
  e.animate({ transform: o ? `translate(${n}px, ${i}px) scale(0.95)` : `translate(${n}px, ${i}px)`, offset: 1 }, { duration: r, easing: s, fill: "both" });
  let a = e.animate({ opacity: 0, offset: 1 }, { duration: lt(r, 0.25), easing: "linear", fill: "both" });
  a.onfinish = () => e.remove();
}
function ue(e, t) {
  let { deltaX: n, deltaY: i, isNew: r, duration: s, ease: o } = t, a = j(e), u = n + a.tx, c = i + a.ty, f = r && a.opacity >= 1 ? 0 : a.opacity;
  e.animate([{ transform: `translate(${u}px, ${c}px) scale(${r ? 0.95 : 1})` }, { transform: "none" }], { duration: s, easing: o, fill: "both" }), f < 1 && e.animate([{ opacity: f }, { opacity: 1 }], { duration: lt(s, r ? 0.5 : 0.25), delay: r ? lt(s, 0.25) : 0, easing: "linear", fill: "both" });
}
function Qe(e, t) {
  let n = 0, i = 0;
  for (let r = e; r && r !== t; r = r.offsetParent) n += r.offsetLeft, i += r.offsetTop;
  return { x: n, y: i };
}
function At(e, t) {
  let n = document.createElement(e);
  return n.setAttribute(Q, ""), n.setAttribute(w, t), n.setAttribute("aria-hidden", "true"), n;
}
function le(e, t) {
  let n = /* @__PURE__ */ new Map();
  for (let i of t) {
    if (i.tagName === "BR") continue;
    let { x: r, y: s } = Qe(i, e), { tx: o, ty: a } = X(i), { width: u, height: c } = et(i), f = Number(getComputedStyle(i).opacity) || 1;
    i.getAnimations().forEach((l) => l.cancel()), n.set(i, { left: r + o, top: s + a, width: u, height: c, opacity: f });
  }
  for (let i = t.length - 1; i >= 0; i--) t[i].tagName === "BR" && (t[i].remove(), t.splice(i, 1));
  t.forEach((i) => {
    let r = n.get(i);
    i.setAttribute(H, ""), i.style.position = "absolute", i.style.pointerEvents = "none", i.style.left = `${r.left}px`, i.style.top = `${r.top}px`, i.style.width = `${r.width}px`, i.style.height = `${r.height}px`, i.style.opacity = String(r.opacity);
  });
}
function ce(e, t) {
  if (t.size === 0) return;
  let n = Array.from(e.children), i = /* @__PURE__ */ new Set();
  for (let r of n) {
    if (r.hasAttribute(H)) continue;
    let s = r.getAttribute(w);
    if (!s || i.has(s)) continue;
    let o = t.get(s);
    if (o) {
      i.add(s);
      for (let a of o) {
        let u = At("span", a.id);
        wt(u, a), r.before(u);
      }
      r.remove();
    }
  }
}
function wt(e, t) {
  if (!t.kind) {
    e.removeAttribute(V), e.removeAttribute(F), e.textContent = t.string;
    return;
  }
  e.setAttribute(V, t.kind), e.setAttribute(F, "");
  let n = e.firstElementChild;
  n || (e.textContent = "", n = document.createElement("span"), e.appendChild(n)), n.textContent = t.string;
}
function vt(e) {
  return e.hasAttribute(F) ? e.firstElementChild ?? e : e;
}
function me(e, t, n, i) {
  let r = /* @__PURE__ */ new Map();
  t.forEach((s) => {
    let o = s.getAttribute(w);
    n.has(o) && !s.hasAttribute(H) && (r.set(o, s), s.remove());
  }), Array.from(e.childNodes).forEach((s) => {
    s.nodeType === Node.TEXT_NODE && s.remove();
  }), i.forEach((s) => {
    let o = r.get(s.id);
    if (o && r.delete(s.id), s.string === `
`) {
      o && o.tagName === "BR" ? e.appendChild(o) : e.appendChild(At("br", s.id));
      return;
    }
    if (o && o.tagName !== "BR") o.style.transformOrigin = "", wt(o, s), e.appendChild(o);
    else {
      let a = At("span", s.id);
      wt(a, s), e.appendChild(a);
    }
  });
}
var Ve = 0.45, Ze = 0.25;
function pe(e, t) {
  let { dx: n, dy: i, slideDistance: r, duration: s, ease: o } = t, a = vt(e);
  e.animate({ transform: `translate(${n}px, ${i}px)`, offset: 1 }, { duration: s, easing: o, fill: "both" }), a.animate({ transform: `translate(0px, ${r}px)`, offset: 1 }, { duration: s, easing: o, fill: "both" });
  let u = a.animate({ opacity: 0, offset: 1 }, { duration: s * Ve, easing: "linear", fill: "both" });
  u.onfinish = () => e.remove();
}
function fe(e, t) {
  let { deltaX: n, deltaY: i, slideDistance: r, kind: s, duration: o, ease: a } = t;
  Rt(e, { deltaX: n, deltaY: i, duration: o, ease: a });
  let u = vt(e), c = j(u), f = s === "digit" ? -r : r;
  u.animate({ transform: `translate(0px, ${c.ty + f}px)`, offset: 0 }, { duration: o, easing: a, fill: "both" });
  let l = c.opacity >= 1 ? 0 : c.opacity;
  l < 1 && u.animate([{ opacity: l }, { opacity: 1 }], { duration: o * Ze, easing: "linear", fill: "both" });
}
function Rt(e, t) {
  let { deltaX: n, deltaY: i, duration: r, ease: s } = t, { tx: o, ty: a } = X(e);
  e.getAnimations().forEach((f) => f.cancel());
  let u = n + o, c = i + a;
  u === 0 && c === 0 || e.animate({ transform: `translate(${u}px, ${c}px)`, offset: 0 }, { duration: r, easing: s, fill: "both" });
}
var tn = 6, de = 0.8, en = 0.45, nn = 0.35;
function he(e) {
  let t = e.map((u) => u.getBoundingClientRect()), n = Math.min(...t.map((u) => u.left)), i = Math.max(...t.map((u) => u.right)), r = Math.min(...t.map((u) => u.top)), s = Math.max(...t.map((u) => u.bottom)), o = (n + i) / 2, a = (r + s) / 2;
  return t.map((u) => `${o - u.left}px ${a - u.top}px`);
}
function ge(e, t) {
  let { duration: n, ease: i } = t, r = he(e);
  e.forEach((s, o) => {
    s.getAnimations().forEach((u) => u.cancel()), s.style.transformOrigin = r[o], s.animate({ transform: `scale(${de})`, offset: 1 }, { duration: n, easing: i, fill: "both" });
    let a = s.animate({ opacity: 0, offset: 1 }, { duration: n * en, easing: "linear", fill: "both" });
    a.onfinish = () => s.remove();
  });
}
function be(e, t) {
  let { duration: n, ease: i } = t, r = he(e);
  e.forEach((s, o) => {
    let a = j(s);
    s.style.transformOrigin = r[o], s.animate({ transform: `scale(${de})`, offset: 0 }, { duration: n, easing: i, fill: "both" });
    let u = a.opacity >= 1 ? 0 : a.opacity;
    s.animate([{ opacity: u }, { opacity: 1 }], { duration: n * nn, easing: "linear", fill: "both" });
  });
}
function It(e, t) {
  let n = [], i = [], r = () => {
    i.length >= tn && n.push(i), i = [];
  };
  for (let s of e) t.has(s) ? i.push(s) : r();
  return r(), n;
}
var rn = "\0#";
function xe(e, t) {
  if (e.segments.length !== 1 || e.word.length <= 1) return e.segments;
  let n = e.segments[0], i = e.word.split("").map((r, s) => ({ id: `${n.id}:${s}`, string: r }));
  return t.set(n.id, i), i;
}
function sn(e) {
  return e.map((t) => ({ ...t, kind: t.kind ?? at(t.string) }));
}
function on(e, t) {
  if (e.length === 0 || t.length === 0) return 0;
  let [n] = G(e.split(""), t.split(""));
  return n.length / Math.max(e.length, t.length);
}
function ye(e, t) {
  let n = [], i = 0;
  for (let r = 0; r < e; r++) n.push(i), t.has(r) && i++;
  return n;
}
var an = 0.4;
function un(e, t) {
  return (q(e) || q(t)) && gt(e) === gt(t) ? 1 : on(e, t);
}
var ln = 2500, cn = 1e6;
function Lt(e, t, n, i = {}) {
  let r = t.includes(" "), s = t.includes(`
`), o = zt(e), a = i.numbers !== false, u = (p) => a && J(p), c = (p) => u(p) ? rn : p, f = a && (q(t) || o.some((p) => q(p.word)));
  if (o.length <= 1 && !r && !s && !f) return { segments: K(t, n, a), splits: /* @__PURE__ */ new Map() };
  let l = [], m = [], d = t.split(/( |\n)/), h = [];
  for (let p of d) p === " " || p === `
` ? h.push(p) : p.length > 0 && (m.push(h), l.push(p), h = []);
  let M = h, x = o.map((p) => p.word);
  if (x.length * l.length > cn) return { segments: K(t, n, a), splits: /* @__PURE__ */ new Map() };
  let [T, L] = G(x.map(c), l.map(c)), E = new Set(T), N = new Set(L), g = /* @__PURE__ */ new Map();
  for (let p = 0; p < L.length; p++) g.set(L[p], T[p]);
  let v = x.map((p, b) => b).filter((p) => !E.has(p)), R = l.map((p, b) => b).filter((p) => !N.has(p)), O = /* @__PURE__ */ new Set();
  for (let p of R) for (let b of v) if (!O.has(b) && c(l[p]) === c(x[b])) {
    g.set(p, b), O.add(b);
    break;
  }
  O.size > 0 && (v = v.filter((p) => !O.has(p)), R = R.filter((p) => !g.has(p)));
  let A = /* @__PURE__ */ new Map(), _ = /* @__PURE__ */ new Set(), B = ye(x.length, E), rt = ye(l.length, N);
  if (v.length * R.length <= ln) for (let p of R) {
    let b = -1, S = an;
    for (let y of v) {
      if (_.has(y) || B[y] !== rt[p]) continue;
      let it = un(x[y], l[p]);
      it > S && (S = it, b = y);
    }
    b >= 0 && (A.set(p, b), _.add(b));
  }
  let pt = l.map((p, b) => {
    let S = g.get(b), y = S ?? A.get(b);
    return y === void 0 ? { mode: "fresh" } : u(p) ? { mode: "number", oi: y } : S !== void 0 ? { mode: "reuse", oi: y } : { mode: "morph", oi: y };
  }), kt = pt.filter((p) => p.mode === "number").length === 1 ? i.cursorIndex : void 0, Ae = xt(n), W = yt();
  for (let p of pt) {
    if (p.mode === "fresh") continue;
    let b = o[p.oi];
    if (p.mode !== "reuse" && b.segments.length === 1) {
      let S = b.segments[0];
      for (let y = 0; y < b.word.length; y++) W.reserve(`${S.id}:${y}`);
    } else for (let S of b.segments) W.reserve(S.id);
  }
  let $ = [], ft = /* @__PURE__ */ new Map(), z = 0;
  function Ht(p) {
    for (let b of p) b === `
` ? $.push({ id: W.take(`newline-${z}`), string: `
` }) : $.push({ id: W.take(`space-${z}`), string: " " }), z++;
  }
  for (let p = 0; p < l.length; p++) {
    Ht(m[p] ?? (p > 0 ? [" "] : []));
    let b = pt[p], S = l[p];
    if (b.mode === "reuse") for (let y of o[b.oi].segments) $.push(y);
    else if (b.mode === "number") {
      let y = o[b.oi];
      $.push(...U(S, sn(xe(y, ft)), kt === void 0 ? void 0 : kt - z, Ae));
    } else if (b.mode === "morph") {
      let y = o[b.oi], it = y.word, we = xe(y, ft), ve = it.split(""), st = S.split(""), [Re, Ot] = G(ve, st), dt = /* @__PURE__ */ new Map();
      for (let I = 0; I < Ot.length; I++) {
        let ot = we[Re[I]];
        ot && dt.set(Ot[I], ot);
      }
      for (let I = 0; I < st.length; I++) if (dt.has(I)) {
        let ot = dt.get(I);
        $.push({ id: ot.id, string: st[I] });
      } else $.push({ id: W.take(`${S}~${I}`), string: st[I] });
    } else u(S) ? $.push(...U(S)) : $.push({ id: W.take(S), string: S });
    z += S.length;
  }
  return Ht(M), { segments: $, splits: ft };
}
var mn = `
[${Y}] {
  display: inline-block;
  position: relative;
  vertical-align: top;
  will-change: width, height;
  white-space: nowrap;
  text-align: inherit;
}

[${Q}]:not(br) {
  display: inline-block;
  position: relative;
  will-change: opacity, transform;
  transform: none;
  opacity: 1;
}

/*
 * The value once as plain text — every other child is an aria-hidden fragment.
 * Out of flow, because the engine measures every child of the root. Clipped
 * rather than display: none, which would take it out of the a11y tree as well.
 * user-select: none, or a copied selection pastes the value twice.
 */
[${P}] {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: pre;
  -webkit-user-select: none;
  user-select: none;
}

/*
 * A digit slides a whole line box to arrive, so it needs its own box to hide
 * behind. Not the root: that spans every line, so clipping there leaves a digit
 * on a middle line sliding over its neighbour in view. The transform sits on the
 * child, so the slide never touches the slot's rect and the FLIP pass stays
 * oblivious. clip-path, not overflow — an inline-block whose overflow is
 * anything but visible has its baseline synthesized to the bottom margin edge
 * (CSS 2.1 §10.8.1), and engines disagree on whether overflow: clip counts.
 * The inline axis stays open so glyph overhang is not shaved.
 */
[${F}] {
  clip-path: inset(0 -100vw);
}

[${F}] > span {
  display: inline-block;
  will-change: opacity, transform;
}

/*
 * Softens the clip above into a gradient, positionally rather than on a timer, so
 * it stays in step with the slide at any duration. The band (--torph-fade, 0 for a
 * hard edge) must eat into the box: the clip trims at the border box, so a ramp
 * reaching past it sits in territory already removed and is never seen. no-clip
 * plus repeat-x is what carries the profile across glyph overhang.
 */
@supports (mask-clip: no-clip) or (-webkit-mask-clip: no-clip) {
  [${F}] {
    --torph-mask: linear-gradient(
      to bottom,
      transparent,
      #000 var(--torph-fade, 0.15em),
      #000 calc(100% - var(--torph-fade, 0.15em)),
      transparent
    );
    -webkit-mask-image: var(--torph-mask);
    mask-image: var(--torph-mask);
    -webkit-mask-repeat: repeat-x;
    mask-repeat: repeat-x;
    -webkit-mask-clip: no-clip;
    mask-clip: no-clip;
  }
}

[${Y}][${Z}] {
  outline: 2px solid magenta;
  [${Q}] {
    outline: 2px solid cyan;
    outline-offset: -4px;
  }
}`, C = null, Nt = 0;
function Se() {
  Nt++, !C && (C = document.createElement("style"), C.dataset.torph = "true", C.textContent = mn, document.head.appendChild(C));
}
function Me() {
  Nt--, !(Nt > 0 || !C) && (C.remove(), C = null);
}
function Te() {
  if (typeof window > "u") return { prefersReducedMotion: false, destroy: () => {
  } };
  let e = window.matchMedia("(prefers-reduced-motion: reduce)"), t = { prefersReducedMotion: e.matches, destroy: i };
  function n(r) {
    t.prefersReducedMotion = r.matches;
  }
  function i() {
    e.removeEventListener("change", n);
  }
  return e.addEventListener("change", n), t;
}
var Ee = { ..._t, debug: false, scale: true, numbers: true }, nt = class {
  constructor(t) {
    __publicField(this, "element");
    __publicField(this, "options", {});
    __publicField(this, "data");
    __publicField(this, "currentMeasures", {});
    __publicField(this, "prevMeasures", {});
    __publicField(this, "previousSegments", []);
    __publicField(this, "isInitialRender", true);
    __publicField(this, "reducedMotion", null);
    __publicField(this, "srNode", null);
    __publicField(this, "hasSetup", false);
    let n = Object.fromEntries(Object.entries(t).filter(([, a]) => a !== void 0)), { ease: i, ...r } = { ...Ee, ...n }, { ease: s, duration: o } = Ft(i, r.duration);
    this.options = { ...r, ease: s, duration: o }, this.element = t.element, this.options.respectReducedMotion && (this.reducedMotion = Te()), this.data = "", this.isDisabled() || this.setup();
  }
  setup() {
    this.hasSetup || (this.hasSetup = true, this.element.setAttribute(Y, ""), this.options.debug && this.element.setAttribute(Z, ""), Se());
  }
  destroy() {
    var _a, _b;
    (_a = this.reducedMotion) == null ? void 0 : _a.destroy(), re(this.element), this.element.getAnimations().forEach((t) => t.cancel()), (_b = this.srNode) == null ? void 0 : _b.remove(), this.srNode = null, this.element.removeAttribute(Y), this.element.removeAttribute(Z), this.hasSetup && (this.hasSetup = false, Me());
  }
  isDisabled() {
    var _a;
    return !!(this.options.disabled || ((_a = this.reducedMotion) == null ? void 0 : _a.prefersReducedMotion));
  }
  update(t, n) {
    let i = typeof t == "number" ? t.toLocaleString(this.options.locale, { minimumFractionDigits: this.options.decimals, maximumFractionDigits: this.options.decimals }) : t;
    if (i !== this.data) {
      if (this.data = i, this.isDisabled()) {
        typeof i == "string" && (this.srNode = null, this.element.textContent = i, this.previousSegments = [], this.isInitialRender = true);
        return;
      }
      if (this.setup(), this.data instanceof HTMLElement) throw new Error("HTMLElement not yet supported");
      this.options.onAnimationStart && !this.isInitialRender && this.options.onAnimationStart(), this.createTextGroup(this.data, this.element, n);
    }
  }
  createTextGroup(t, n, i) {
    let { width: r, height: s } = et(n), o = this.options.numbers !== false;
    this.syncAccessibleText(t);
    let a, u;
    if (this.previousSegments.length > 0) {
      let g = Lt(this.previousSegments, t, this.options.locale, { numbers: o, cursorIndex: i });
      a = g.segments, u = g.splits;
    } else a = K(t, this.options.locale, o), u = /* @__PURE__ */ new Map();
    let c = a.length === 0;
    c && (a = [{ id: tt, string: "​" }]), ce(n, u), this.prevMeasures = ct(this.element);
    let f = Array.from(n.children).filter((g) => !g.hasAttribute(P)), l = new Set(a.map((g) => g.id)), m = f.filter((g) => !l.has(g.getAttribute(w)) && !g.hasAttribute(H)), d = new Set(m), h = f.map((g) => g.getAttribute(w)), M = oe(f, d, h, l);
    le(n, m), me(n, f, l, a), this.currentMeasures = ct(this.element);
    let x = a.reduce((g, v) => v.string === `
` ? g + 1 : g, 1), T = (n.offsetHeight || 20 * x) / x;
    n.style.width = `${r}px`, n.offsetWidth;
    let L = ct(this.element);
    n.style.width = "", this.updateStyles(a, L, T);
    let E = this.isInitialRender ? [] : It(f, new Set(m)), N = new Set(E.flat());
    for (let g of E) ge(g, { duration: this.options.duration, ease: this.options.ease });
    if (m.forEach((g) => {
      if (this.isInitialRender || g.getAttribute(w) === tt) {
        g.remove();
        return;
      }
      if (N.has(g)) return;
      let v = M.get(g), { dx: R, dy: O } = v ? Tt(this.currentMeasures, this.prevMeasures, v) : { dx: 0, dy: 0 };
      g.hasAttribute(V) ? pe(g, { dx: R, dy: O, slideDistance: T, duration: this.options.duration, ease: this.options.ease }) : ae(g, { dx: R, dy: O, duration: this.options.duration, ease: this.options.ease, scale: this.options.scale });
    }), this.previousSegments = a, this.isInitialRender) {
      this.isInitialRender = false, n.style.width = "", n.style.height = "";
      return;
    }
    c ? se(n, r, s, this.options.duration, this.options.onAnimationComplete, this.options.onAnimationCancel) : ie(n, r, s, this.options.duration, this.options.ease, this.options.onAnimationComplete, this.options.onAnimationCancel);
  }
  updateStyles(t, n, i) {
    if (this.isInitialRender) return;
    let r = Array.from(this.element.children).filter((l) => !l.hasAttribute(P)), s = t.map((l) => l.id), o = new Map(t.map((l) => [l.id, l.kind])), a = r.filter((l) => !l.hasAttribute(H) && l.tagName !== "BR" && l.getAttribute(w) !== tt), u = new Set(a.filter((l) => !this.prevMeasures[l.getAttribute(w)])), c = /* @__PURE__ */ new Set();
    for (let l of It(a, u)) l.forEach((m) => c.add(m)), be(l, { duration: this.options.duration, ease: this.options.ease });
    let f = new Set(s.filter((l) => this.prevMeasures[l]));
    r.forEach((l, m) => {
      if (l.hasAttribute(H) || l.tagName === "BR" || c.has(l)) return;
      let d = l.getAttribute(w) || `child-${m}`;
      if (d === tt) return;
      let h = !this.prevMeasures[d], M = h ? Et(t.findIndex((E) => E.id === d), s, f) : d, { dx: x, dy: T } = M ? Tt(this.prevMeasures, n, M) : { dx: 0, dy: 0 }, L = o.get(d);
      L && h ? fe(l, { deltaX: x, deltaY: T, slideDistance: i, kind: L, duration: this.options.duration, ease: this.options.ease }) : L ? Rt(l, { deltaX: x, deltaY: T, duration: this.options.duration, ease: this.options.ease }) : ue(l, { deltaX: x, deltaY: T, isNew: h, duration: this.options.duration, ease: this.options.ease });
    });
  }
  syncAccessibleText(t) {
    if (!this.srNode || this.srNode.parentNode !== this.element) {
      let n = document.createElement("span");
      n.setAttribute(P, ""), this.element.prepend(n), this.srNode = n;
    }
    this.srNode.textContent = t;
  }
};
const instances = /* @__PURE__ */ new WeakMap();
function morphOptions(element, content) {
  const duration = Number(element.getAttribute("duration"));
  return {
    element: content,
    duration: element.hasAttribute("duration") && Number.isFinite(duration) && duration >= 0 ? duration : void 0,
    ease: element.getAttribute("ease") || void 0,
    locale: element.getAttribute("locale") || void 0
  };
}
function enhance(element) {
  if (instances.has(element)) return;
  const state = {
    text: element.textContent || "",
    content: document.createElement("span"),
    morph: null,
    observer: null
  };
  function update(value) {
    const nextText = String(value ?? "");
    if (nextText === state.text) return;
    state.text = nextText;
    state.morph.update(nextText);
  }
  function createMorph() {
    var _a;
    (_a = state.morph) == null ? void 0 : _a.destroy();
    state.content.textContent = state.text;
    state.morph = new nt(morphOptions(element, state.content));
    state.morph.update(state.text);
  }
  element.replaceChildren(state.content);
  createMorph();
  Object.defineProperty(element, "textContent", {
    configurable: true,
    get: () => state.text,
    set: update
  });
  state.observer = new MutationObserver((changes) => {
    if (changes.some((change) => change.type === "attributes")) createMorph();
    if (element.childNodes.length === 1 && element.firstChild === state.content) return;
    const externalNodes = [...element.childNodes].filter((node) => node !== state.content);
    const nextText = (element.contains(state.content) ? state.text : "") + externalNodes.map((node) => node.textContent).join("");
    element.replaceChildren(state.content);
    update(nextText);
  });
  state.observer.observe(element, { childList: true, attributes: true, attributeFilter: ["duration", "ease", "locale"] });
  instances.set(element, state);
}
function release(element) {
  const state = instances.get(element);
  if (!state) return;
  state.observer.disconnect();
  state.morph.destroy();
  delete element.textContent;
  element.textContent = state.text;
  instances.delete(element);
}
function visit(node, callback) {
  if (!(node instanceof Element)) return;
  if (node.matches("torph")) callback(node);
  node.querySelectorAll("torph").forEach(callback);
}
document.querySelectorAll("torph").forEach(enhance);
new MutationObserver((changes) => {
  for (const change of changes) {
    change.addedNodes.forEach((node) => visit(node, enhance));
    change.removedNodes.forEach((node) => visit(node, (element) => {
      if (!element.isConnected) release(element);
    }));
  }
}).observe(document, { childList: true, subtree: true });
